




import { Image } from './image';
export default Image;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/image.vue